import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-evento-cifrischain',
  templateUrl: './evento-cifrischain.component.html',
  styleUrls: ['./evento-cifrischain.component.css']
})
export class EventoCifrischainComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
